module.exports = __webpack_public_path__ + "img/banner.cd028848.png";